import { useEffect, useRef } from 'react';

const CHECKBOX_CLASS = 'size-4 rounded border-gray-300 accent-gray-400 cursor-pointer';

// Table row / select-all checkbox. Supports the indeterminate state for a
// partially-selected page, and stops click propagation so a click doesn't
// also trigger the row's own handlers.
export default function RowCheckbox({ checked, indeterminate, onChange, className = '', ariaLabel }) {
	const ref = useRef(null);
	useEffect(() => {
		if (ref.current) ref.current.indeterminate = !!indeterminate;
	}, [indeterminate]);

	return (
		<input
			ref={ref}
			type='checkbox'
			aria-label={ariaLabel}
			className={`${CHECKBOX_CLASS} ${className}`}
			checked={checked}
			onChange={onChange}
			onClick={(e) => e.stopPropagation()}
		/>
	);
}
